import * as React from 'react';
import moment from 'moment-timezone';
import { DateFormat, TimeFormat } from '../../../../../../../utils/dateFormat';

export const renderMessageId = (messageId = ''): JSX.Element => <>{messageId.split('-')[0]}</>;

export const renderDate = (date?: string): JSX.Element =>
  date ? <>{moment(date).format(`${DateFormat.Short} ${TimeFormat.WithSeconds}`)}</> : <></>;
